import { Autocomplete, Stack, TextField, Typography } from "@mui/material";
import { formatTitle } from "../utils";
import { EnumField } from "../ConfigFields/EnumField";

const CompareTagPreset = ({ schema, config, handleConfigChange, tags }) => {
  return (
    <Stack spacing={3}>
      <EnumField
        label={formatTitle("mode")}
        schema={schema?.properties["mode"] || {}}
        value={config["mode"] || ""}
        onChange={(val) => handleConfigChange("mode", val)}
      />
        
      <Autocomplete
        options={tags || []}
        value={tags?.filter((tag) => config["tags"]?.includes(tag.id)) || ""}
        multiple
        onChange={(e, newValue) =>
          handleConfigChange(
            "tags",
            newValue.map((tag) => tag.id),
          )
        }
        renderInput={(params) => (
          <TextField
            {...params}
            label="Select Tags"
            variant="outlined"
            required={true}
            size="small"
          />
        )}
        getOptionLabel={(option) => option?.name || ""}
        renderOption={(props, option) => (
          <Stack
            {...props}
            key={option?.id}
            direction="column"
            gap={0.5}
            sx={{
              alignItems: "flex-start !important",
              textAlign: "left",
              width: "100%",
            }}
          >
            <Typography>{option?.name}</Typography>
          </Stack>
        )}
        isOptionEqualToValue={(option, value) => option?.id === value?.id}
        noOptionsText="No Tags found"
      />
    </Stack>
  );
};

export default CompareTagPreset;
